import React, {Component} from "react";
import PropTypes from "prop-types";
import LinearProgress from "@material-ui/core/LinearProgress";

export class LoadingLogo extends Component {
	static propTypes = {
		loading: PropTypes.bool,
		style: PropTypes.any,
		message: PropTypes.string,
	};

	static defaultProps = {
		loading: true,
	};

	render() {
		if (this.props.message) {
			return (
				<div
					className={
						"m-2 bg-white rounded border border-custom"
					}
					style={{
						padding: "80px",
						width: "600px",
						position: "absolute",
						left: "calc(50% + 100px)",
						top: "50%",
						transform: "translate(-50%, -50%)",
					}}
				>
					<div style={{ top: "50%", position: "relative", textAlign: "center" }}>
						<h4>{this.props.message}</h4>
						<LinearProgress />
					</div>
				</div>
			);
		} else
			return (
				<div
					style={
						{
							position: "relative",
							userSelect: "none",
							...this.props.style,
						}
					}
					className={
						this.props.loading
							? ""
							: "hidden"
					}
				>
					<p>{this.props.message}</p>
					<img
						style={
							{
								width: "225px",
								maxWidth: "90%",
								maxHeight: "90%",
								position: "absolute",
								left: "50%",
								top: "50%",
								transform: "translate(-50%, -50%)",
							}
						}
						src="/assets/img/loading.gif" alt="loading..."/>
				</div>
			);
	}
}
